import { syntaxHighlighting } from '@codemirror/language';
import type { Extension } from '@codemirror/state';
import { tooltips } from '@codemirror/view';

import { EscapedCharacterDecorationPlugin } from '../decorations/escaped-characters.js';
import { FilterErrorDecorationPlugin } from '../decorations/filter-errors.js';
import { FilterExistsDecorationPlugin } from '../decorations/filter-exists-operator.js';
import { FilterKeyDecorationPlugin } from '../decorations/filter-keys.js';
import { FilterSearchDecorationPlugin } from '../decorations/filter-search.js';
import { FilterStatementDeleteWidgetPlugin } from '../decorations/filter-statements-delete-widget.js';
import { FilterStatementDecorationPlugin } from '../decorations/filter-statements.js';
import { FilterValueDecorationPlugin } from '../decorations/filter-values.js';
import { FilterVariableDecorationPlugin } from '../decorations/filter-variable.js';
import { filterFieldHighlighter } from '../decorations/highlight.js';
import { createWildcardInValueDecorationPlugin } from '../decorations/wildcards-in-value.js';

export function createFilterFieldSyntaxHighlightingExtension(
  matchesWildcardConversion: boolean,
): Extension {
  return [
    // Enable highlighting using the defined highlighter.
    // This adds the spans and classes used to style the different parts of a filter.
    syntaxHighlighting(filterFieldHighlighter),
    // Add decoration plugins for wrapping filter groups, statements, keys, and values
    // in additional spans for styling. This is not possible using only a highlighter
    // since the highlighter can only wrap nodes that have no more nesting levels.
    EscapedCharacterDecorationPlugin,
    FilterKeyDecorationPlugin,
    FilterSearchDecorationPlugin,
    FilterVariableDecorationPlugin,
    FilterValueDecorationPlugin,
    createWildcardInValueDecorationPlugin(matchesWildcardConversion),
    FilterExistsDecorationPlugin,
    // Errors must be listed after all inner decorations: CodeMirror renders later
    // plugins as the outer span, so an earlier error mark would be split into several
    // spans by e.g. a wildcard inside it — each drawing its own dotted underline.
    FilterErrorDecorationPlugin,
    FilterStatementDeleteWidgetPlugin,
    FilterStatementDecorationPlugin,

    tooltips({ parent: document.body }),
  ];
}
